module.exports = __webpack_public_path__ + "img/logo-smart-horizontal.dd2c7e7c.png";